import type { InterestZoneSavedMapDetail, InterestZoneSavedMapListItem } from '@gozoki/api-types'
import { gozokiApiWithAuth } from '../gozokiApi'

export const fetchInterestZoneSavedMaps = async (): Promise<InterestZoneSavedMapListItem[]> => {
  const { data } = await gozokiApiWithAuth.get<InterestZoneSavedMapListItem[]>(
    '/interest-zone-saved-maps',
  )
  return data
}

export const fetchInterestZoneSavedMap = async (
  id: number,
): Promise<InterestZoneSavedMapDetail> => {
  const { data } = await gozokiApiWithAuth.get<InterestZoneSavedMapDetail>(
    `/interest-zone-saved-maps/${id}`,
  )
  return data
}
